export class GeozipGrid {
    id=0;
    speciality = '';
    zipCode = '';
    geoZip = '';
    zipArea = '';
}
